module.exports = __webpack_public_path__ + "img/cart-icon-stroke.d55f37f.svg";